<dynamic-form
  *ngIf="formGroup && formGroupIsOk"
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [columns]="columns"
  [isShowModal]="false"
  [defaultHeight]="25"
  [hasDefault]="false"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content">
    <div class="row">
      <div *ngIf="StatusKindIds" class="col-4">
        <ssg-select
          name="StatusKindIds"
          [multiple]="true"
          [group]="formGroup"
          dropdownPosition="auto"
          limitSelection="5"
          userClass="select-md"
          [hasCheckBox]="true"
          [hasSelectAll]="true"
          label="وضعیت سند"
          apiName="Lookup"
          systemName="ACC"
          category="StatusKind"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>
      </div>
      <div *ngIf="SystemKindIds" class="col-4">
        <ssg-select
          name="SystemKindIds"
          [multiple]="true"
          [group]="formGroup"
          dropdownPosition="auto"
          limitSelection="5"
          userClass="select-md"
          [hasCheckBox]="true"
          [hasSelectAll]="true"
          label="نوع سیستم"
          apiName="Lookup"
          systemName="GNR"
          category="SystemKind"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>
      </div>
      <div *ngIf="AccVoucherKindIds" class="col-4">
        <ssg-select
          name="AccVoucherKindIds"
          [multiple]="true"
          [group]="formGroup"
          dropdownPosition="auto"
          limitSelection="5"
          userClass="select-md"
          [hasCheckBox]="true"
          [hasSelectAll]="true"
          label="نوع سند"
          apiName="AccVoucherKind/ReadAccVoucherKindLookUp"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>
      </div>
      <div *ngIf="GeneralLedgerIds" class="col-4">
        <ssg-select
          name="GeneralLedgerIds"
          [multiple]="true"
          [group]="formGroup"
          userClass="select-md"
          dropdownPosition="auto"
          limitSelection="5"
          [hasCheckBox]="true"
          [hasSelectAll]="true"
          label="حساب کل"
          apiName="GeneralLedger/ReadLookUp"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>
      </div>
      <div *ngIf="SubLedgerIds" class="col-4">
        <ssg-select
          name="SubLedgerIds"
          [multiple]="true"
          userClass="select-md"
          [group]="formGroup"
          dropdownPosition="auto"
          limitSelection="5"
          [hasCheckBox]="true"
          [hasSelectAll]="true"
          label="حساب معین"
          apiName="SubLedger/ReadLookUp"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>
      </div>
      <div *ngIf="DetailLedger1Ids" class="col-4">
        <ssg-select
          name="DetailLedger1Ids"
          [multiple]="true"
          [group]="formGroup"
          userClass="select-md"
          dropdownPosition="auto"
          limitSelection="5"
          [hasCheckBox]="true"
          [hasSelectAll]="true"
          [label]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger1' | translate"
          apiName="DetailLedger/ReadLookUp"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>
      </div>
      <div *ngIf="DetailLedger2Ids" class="col-4">
        <ssg-select
          name="DetailLedger2Ids"
          [multiple]="true"
          [group]="formGroup"
          userClass="select-md"
          dropdownPosition="auto"
          limitSelection="5"
          [hasCheckBox]="true"
          [hasSelectAll]="true"
          [label]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger2' | translate"
          apiName="DetailLedger/ReadLookUp"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>
      </div>
      <div *ngIf="DetailLedger3Ids" class="col-4">
        <ssg-select
          name="DetailLedger3Ids"
          [multiple]="true"
          [group]="formGroup"
          userClass="select-md"
          dropdownPosition="auto"
          limitSelection="5"
          [hasCheckBox]="true"
          [hasSelectAll]="true"
          [label]="'ClientApp.BackOffice.ACC.SubLedger.DetailLedger3' | translate"
          apiName="DetailLedger/ReadLookUp"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>
      </div>
    </div>
  </ng-container>
</dynamic-form>
